import React from 'react';
import { CalendarIcon } from '@revfluence/fresh-icons/solid/esm';
import { Badge } from '@/shadcn/components/ui/badge';
import { cn } from '@/shadcn/lib/utils';
import { DEFAULT_VALUES } from './constants';
import { formatDate } from '@/applications/Social/utils/shared/date-helpers';

export interface SheetTopBarDateBadgeProps {
  /** The date to display */
  date: Date | string;
  /** Optional additional CSS classes */
  className?: string;
  /** Optional variant for the badge */
  variant?: 'default' | 'secondary' | 'destructive' | 'outline';
}

/**
 * SheetTopBarDateBadge
 * ---------------------
 * Displays a date badge with calendar icon in the sheet top bar.
 *
 * Used in content preview sheets to show post creation date.
 */
const SheetTopBarDateBadge: React.FC<SheetTopBarDateBadgeProps> = ({
  date,
  className,
  variant = DEFAULT_VALUES.DATE_BADGE_VARIANT,
}) => {
  return (
    <Badge
      variant={variant}
      className={cn(
        'flex items-center gap-2 rounded-lg bg-gray-200 text-gray-700 hover:bg-gray-200 hover:no-underline',
        className
      )}
    >
      <CalendarIcon className="h-3 w-3" />
      <span>{formatDate(date)}</span>
    </Badge>
  );
};

export default SheetTopBarDateBadge;
